import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect } from 'react';
import type { JSX } from 'react';
import Typography from '@mui/material/Typography';
import type { Theme} from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import type { RunContextProps } from '../Contexts/RunContext';
import RunContext from '../Contexts/RunContext';

type ErrorPageProps = {
    errorMessage: string,
};

function ErrorPage(props: Readonly<ErrorPageProps>): JSX.Element {

    const runContext: RunContextProps = useContext<RunContextProps>(RunContext);

    const currentTheme: Theme = useTheme();

    useEffect(() => {
        runContext.setTitle('K-Fleet Vessel Manager');
    }, [runContext]);

    return (
        <div style={{
            textAlign: 'center',
            padding: '105px 5px 5px 5px',
        }}>
            <FontAwesomeIcon
                icon={faTriangleExclamation}
                size='5x'
                color={currentTheme.palette.error.main}
            />
            <br />
            <br />
            <br />
            <Typography style={{
                color: currentTheme.palette.text.primary,
            }}>
                {props.errorMessage}
            </Typography>
        </div>
    );
}

export default ErrorPage;